// extracted by mini-css-extract-plugin
export default {"container":"Z1d8ha","category":"Vqf3fQ","categoryName":"bQ44Jv","items":"hYob5m","text":"gDat0j"};